import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import { useHistory } from "react-router-dom";
import { LOANPLANTYPEID } from "../../config/cacheKey";
import { GetAllLoanTemplatesResponse } from "../../models/loanTemplate.model";
import LinearGradientBox from "../../components/box/linearGradientBox";

const loanPlanTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 350,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default function LoanPlan(item: GetAllLoanTemplatesResponse) {
  const history = useHistory();
  const handleDetailes = (id: number) => {
    localStorage.setItem(LOANPLANTYPEID, String(id));
    history.push("/plans/loanPlanDetail");
  };

  const detailItems = [
    {
      label: "نوع طرح",
      value: item.isLoanTemplatePublic ? "عمومی" : "خصوصی",
    },
    {
      label: "نوع بازپرداخت",
      value: item.repaymentTypeTitle,
    },
    {
      label: "روش پرداخت هزینه اشتراک",
      value: item.feePaymentTypeTitle,
    },
  ];

  return (
    <ThemeProvider theme={loanPlanTheme}>
      <Card
        variant="outlined"
        sx={{
          borderRadius: "14px !important",
          backgroundColor: "#FFFFFF",
          mb: 2,
          mx: 2,
          border: "1px solid #D9DDE1",
          boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.05)",
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "center", sm: "center" },
                justifyContent: "space-between",
                gap: 2,
                // direction: { xs: "rtl", sm: "ltr" },
                p: { xs: 2, md: 3 },
              }}
            >
              <Box
                sx={{
                  width: { xs: 92, md: 122 },
                  height: { xs: 62, md: 76 },
                  alignSelf: { xs: "center", sm: "auto" },
                  borderRadius: "8px",
                  overflow: "hidden",
                  background: item.walletTypeLogo
                    ? "#FFFFFF"
                    : `linear-gradient(160deg, rgba(255,255,255,0.88), ${item.walletTypeColorHexCode})`,
                  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.12)",
                  flexShrink: 0,
                }}
              >
                {item.walletTypeLogo && (
                  <LinearGradientBox color={item.walletTypeColorHexCode} />
                )}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  textAlign: { xs: "center", sm: "start" },
                  direction: "rtl",
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{
                    color: "#2B2B2B",
                    fontWeight: 700,
                    fontSize: "1.2rem",
                    lineHeight: 1.5,
                    mb: 1,
                  }}
                >
                  {item.loanTemplateTitle}
                </Typography>

                {item.walletTypeTitle && (
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#1D4A87",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "8px",
                      color: "#FFFFFF",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    {item.walletTypeTitle}
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  minWidth: "fit-content",
                  border: "1px solid",
                  borderColor: item.isActive ? "#28A745" : "#E6123D",
                  color: item.isActive ? "#28A745" : "#E6123D",
                  borderRadius: "16px",
                  px: 1.5,
                  py: 0.5,
                  fontSize: "0.95rem",
                  fontWeight: 700,
                  lineHeight: 1.4,
                }}
              >
                {item.isActive ? "فعال" : "غیرفعال"}
              </Box>
            </Box>

            <Box
              sx={{
                overflow: "hidden",
                borderTop: "1px solid #E9ECEF",
                marginTop: "20px",
                mx: { xs: 2, md: 3 },
              }}
            >
              {detailItems.map((detail, index) => (
                <Grid
                  container
                  key={detail.label}
                  sx={{
                    minHeight: 38,
                    alignItems: "center",
                    borderBottom:
                      index === detailItems.length - 1
                        ? "none"
                        : "1px solid #E9ECEF",
                  }}
                >
                  <Grid
                    item
                    xs={5}
                    sx={{
                      px: 2,
                      color: "#6B7280",
                      fontWeight: 500,
                      borderLeft: "1px solid #E9ECEF",
                      textAlign: "right",
                    }}
                  >
                    <Typography fontWeight={500}>{detail.label}:</Typography>
                  </Grid>
                  <Grid item xs={7} sx={{ px: 2, textAlign: "center" }}>
                    <Typography sx={{ color: "#2F3A45", fontWeight: 600 }}>
                      {detail.value}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>

          <Box
            onClick={() => handleDetailes(item.loanTemplateId)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              px: { xs: 2, md: 3 },
              py: 1.5,
              color: "#1D4A87",
              borderTop: "1px solid #E6E8EB",
              backgroundColor: "#FAFBFC",
              cursor: "pointer",
              fontWeight: 700,
            }}
          >
            <Typography fontWeight={700} sx={{ color: "inherit" }}>
              مشاهده جزئیات
            </Typography>
            <ArrowBackIosIcon sx={{ fontSize: "0.95rem" }} />
          </Box>
        </CardContent>
      </Card>
    </ThemeProvider>
  );
}
